import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import _ from 'lodash';
import BreadCrumb from 'jbc-front/components/BreadCrumb';
import {
  CLIENT_SETTINGS,
  COORDINATION_SERVICE_LIST
} from 'src/constants/EndpointUrls';
import { SYNC_COMMON_ID_SETTING_FORM } from 'src/constants/FormNames';
import { useTranslation } from 'react-i18next';
import SyncCommonIdInsideForm from './components/SyncCommonIdInsideForm';
import { saveClientSyncCommonIdSettings, REDUCER_NAME } from 'src/reducers/clients/syncCommonIdSettings';
import { getItem } from 'src/reducers/common/itemReducer';
import { setItem } from 'src/reducers/common/itemReducer';
import styles from './SyncCommonIdSettings.scss';

let SyncCommonIdSettingForm = reduxForm({
  form: SYNC_COMMON_ID_SETTING_FORM
})(SyncCommonIdInsideForm);


const mapStateToProps = state => ({
  initialValues: {
    ...getItem(REDUCER_NAME, state)
  }
});

const mapDispatchToProps = dispatch => ({
  onSubmit: data => {
    dispatch(saveClientSyncCommonIdSettings(data))
  }
});

SyncCommonIdSettingForm = connect(mapStateToProps, mapDispatchToProps)(SyncCommonIdSettingForm);

const Note = () => {
  const { t } = useTranslation();
  return (
    <div>
      <p className={styles.notes}>
        {t('features.Coordinations.SyncCommonIdSettings.this_is_the_setting_for_API_integration_with_jbc_common_id')}
      </p>
      <div className={styles.innerNotes}>
        <p>
          {t('features.Coordinations.SyncCommonIdSettings.setting_up_the_linkage_with_jbc_common_id')}<br />
          {t('features.Coordinations.SyncCommonIdSettings.check_each_item_you_want_to_link_with_JOBCAN_Common_ID')}<br />
          {t('features.Coordinations.SyncCommonIdSettings.Please_note_that_if_you_turn_off_this_item_and_you_are_also_using_JOBCAN_Attendance_any_changes_make_to_the_attendance_system_will_not_be_linked_to_the_payroll_system')}<br />
          {t('features.Coordinations.SyncCommonIdSettings.JOBCAN_ties_user_information_with_email_address_and_staff_codes')}<br />
          {t('features.Coordinations.SyncCommonIdSettings.We_recommend_that_you_do_not_turn_off_the_linkage_settings_for_email_addresses_and_staff_codes')}<br />
        </p>
      </div>
    </div>
  );
};
const SyncCommonIdSettings = ({ dispatch, values }) => {
  const { t } = useTranslation();
  dispatch(setItem(REDUCER_NAME, values));

  return (
    <React.Fragment>
      <div className="l-main-title-wrap">
        <h1 className="m-title-main">{t('features.Coordinations.SyncCommonIdSettings.setting_up_the_linkage_with_JBC_common_id')}</h1>
      </div>
      <div className="l-wrap-xl l-contents-wrap">
        <BreadCrumb>
          <BreadCrumb.Item label={t('features.Coordinations.SyncCommonIdSettings.setting')} path={CLIENT_SETTINGS} />
          <BreadCrumb.Item label={t('features.Coordinations.SyncCommonIdSettings.service_link')} path={COORDINATION_SERVICE_LIST} />
          <BreadCrumb.Item label={t('features.Coordinations.SyncCommonIdSettings.setting_up_the_linkage_with_JBC_common_id')} />
        </BreadCrumb>
        <Note />
      </div>
      <div className="l-wrap-xs">
        <div className="u-mt20">
          <SyncCommonIdSettingForm />
        </div>
      </div>
    </React.Fragment>
  );
};

export default connect()(SyncCommonIdSettings);
